
import Button from "@/Components/Buttons/Button.vue";
import Card from "@/Components/General/Card.vue";
import Multiselect from "@/Components/General/Multiselect.vue";
import AppLayoutVue from "@/Layouts/AppLayout.vue";
import { useForm } from "@inertiajs/inertia-vue3";
import dayjs from "dayjs";
import { PropType, defineComponent } from "vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiContentSave, mdiLoading, mdiPrinter, mdiFileExport } from "@mdi/js";
import { Invoice } from "@/types/Invoice";
import Pagination from "@/types/Pagination";
import InvoicesTable from "@/Components/Reports/InvoicesTable.vue";

export default defineComponent({
  layout: AppLayoutVue,
  props: {
    invoices: {
      type: Object as PropType<Pagination<Invoice>>,
      required: false,
    },
    date_from: {
      type: String,
      required: false,
    },
    date_to: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    only_labour: {
      type: String,
      required: false,
    },
    invoice_number: {
      type: String,
      required: false,
    },
    credit_note: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const form = useForm({
      filter: true,
      date_from: props.date_from ?? dayjs().format("YYYY-MM-DD"),
      date_to: props.date_to ?? dayjs().format("YYYY-MM-DD"),
      type: props.type ?? "all",
      only_labour: props.only_labour,
      invoice_number: props.invoice_number ?? "",
      credit_note: props.credit_note ?? "all",
    });

    const submit = () => {
      console.log("Submitting.");
      console.log(route("reports.invoices.show"));
      form.get(route(route().current() ?? ""));
    };

    const print = () => {
      // @ts-ignore
      window.open(route("reports.invoices.print", form.data()));
    };

    const exportInvoices = () => {
      // @ts-ignore
      const query = new URLSearchParams(form.data()).toString();
      window.location.href = `${route('reports.invoices.export')}?${query}`;
    };

    return {
      form,
      submit,
      print,
      mdiContentSave,
      mdiLoading,
      mdiFileExport,
      printIcon: mdiPrinter,
      exportInvoices,
    };
  },
  components: { Multiselect, Card, Button, SvgIcon, InvoicesTable },
});
